var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 10.05c0 4.475 3.25 8.195 7.5 8.95v-6.5H6.25V10H8.5V8c0-2.25 1.45-3.5 3.5-3.5.65 0 1.35.1 2 .2V7h-1.15c-1.1 0-1.35.55-1.35 1.25V10h2.4l-.4 2.5h-2V19c4.25-.755 7.5-4.475 7.5-8.95C19 5.072 14.95 1 10 1s-9 4.072-9 9.05Z",
    fill: "#2F88FF"
  })));
};
export default SvgFacebook;